import { Type } from "class-transformer";
import { observable } from "mobx";
import Vehicle from "./vehicle";
import FuelType from "../entities/fuelType";

export default class ChargeValidity {
  @observable
  id: string;

  @observable
  chargeTypeId: string;

  @Type(() => Date)
  @observable
  validSince: Date;

  @Type(() => Date)
  @observable
  validUntil: Date;

  @observable
  fuelType: FuelType;

  @Type(() => Vehicle)
  @observable
  vehicle: Vehicle;

  @observable
  authCode: string;
}
